import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import styles from './styles.module.scss'
const CloudflareVideo = dynamic(
  () => import('../../../elements/CloudflareVideo'),
  { ssr: false }
)
const Button = dynamic(() => import('../../../elements/Button'), {
  ssr: false
})
const Video = ({ pageData, translations }) => {
  const router = useRouter()
  return (
    <div>
      <div className={styles.video}>
        <CloudflareVideo
          loop
          title="Sxmsir Presentation video"
          autoplay
          muted
          src={
            pageData.cloudflare_video
              ? pageData.cloudflare_video
              : pageData.video
          }
        />

        <div className={styles.overlay}></div>
      </div>

      <div className={styles.content}>
        <h2
          dangerouslySetInnerHTML={{
            __html: translations.page.video.title[router.locale]
          }}
          className={styles.title}
        ></h2>

        <Button href="/vacation-rentals">
          {translations.page.video.button[router.locale]}
        </Button>
      </div>
    </div>
  )
}

export default Video
